module.exports = __webpack_public_path__ + "img/art1.9fe18b28.jpg";